import { RefObject } from 'react';
import { IconButton } from 'src/components/Buttons/IconButton';
import { vars } from 'src/core/themes';
import { Popover } from 'src/core/ui';
import { DownRightArrowIcon } from 'src/svgs/Viagogo/functional-svgs/DownRightArrow';
import { ContentId } from 'src/utils/constants/contentId';

import { RetailUnpaidSale } from '../RetailTable.types';
import * as styles from './RetailTableComponents.css';
import { SalePill } from './SalePill';

export function SaleSearchPopover({
  sales,
  onOpenSale,
  searchQuery,
  onSearchQueryChange,
  anchorRef,
}: {
  sales: RetailUnpaidSale[];
  onOpenSale: (sale: RetailUnpaidSale) => void;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  anchorRef: RefObject<HTMLDivElement | null>;
}) {
  const filteredSales = sales.filter((sale) => {
    const query = searchQuery.toLowerCase();
    return (
      String(sale.id).includes(query) ||
      sale.label.toLowerCase().includes(query)
    );
  });

  const anchorHeight = anchorRef.current?.offsetHeight ?? 0;

  return (
    <>
      <Popover.Trigger asChild>
        <div className={styles.triggerWrapper}>
          <IconButton
            icon={
              <DownRightArrowIcon
                size={vars.iconSize.xxs}
                withHoverEffect
                fill={vars.color.textBrandV2}
              />
            }
            titleContentId={ContentId.Search}
          />
        </div>
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="start"
        sideOffset={-anchorHeight}
        style={{ backgroundColor: vars.color.surfaceSubtle }}
      >
        <div className={styles.popoverInner}>
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            type="text"
            className={styles.searchInput}
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
          />
          <div className={styles.resultsContainer}>
            {filteredSales.length === 0 ? (
              <div className={styles.noResults}>No results</div>
            ) : (
              filteredSales.map((sale) => (
                <Popover.Close asChild key={sale.id}>
                  <SalePill
                    label={sale.label}
                    onOpen={() => onOpenSale(sale)}
                  />
                </Popover.Close>
              ))
            )}
          </div>
        </div>
      </Popover.Content>
    </>
  );
}
